import { AutomationRuleFilterInterface } from 'modules/automation-rules/types/automation-rule-filter-interface'

export const getTriggerFilterQuery = (filter: AutomationRuleFilterInterface) =>
  `${filter.trigger ? `&filter[trigger][type]=${filter.trigger}` : ''}${
    filter.triggerTagId ? `&filter[trigger][tagId]=${filter.triggerTagId}` : ''
  }${filter.triggerCampaignId ? `&filter[trigger][campaignId]=${filter.triggerCampaignId}` : ''}${
    filter.blogId ? `&filter[trigger][blogId]=${filter.blogId}` : ''
  }${filter.blogEntity ? `&filter[trigger][blogEntity]=${filter.blogEntity}` : ''}${
    filter.blogPageEntityId || filter.blogPostEntityId
      ? `&filter[trigger][pageId]=${filter.blogPageEntityId || filter.blogPostEntityId}`
      : ''
  }${
    filter.newSaleFunnelId ||
    filter.cancelSaleFunnelId ||
    filter.pageVisitedFunnelId ||
    filter.formSubscribeFunnelId ||
    filter.webinarFunnelId
      ? `&filter[trigger][funnelId]=${
          filter.newSaleFunnelId ||
          filter.cancelSaleFunnelId ||
          filter.pageVisitedFunnelId ||
          filter.formSubscribeFunnelId ||
          filter.webinarFunnelId
        }`
      : ''
  }${
    filter.formSubscribeFunnelStepId ||
    filter.pageVisitedFunnelStepId ||
    filter.newSaleFunnelStepId ||
    filter.cancelSaleFunnelStepId ||
    filter.subscriptionFailedFunnelStepId
      ? `&filter[trigger][funnelStepId]=${
          filter.formSubscribeFunnelStepId ||
          filter.pageVisitedFunnelStepId ||
          filter.newSaleFunnelStepId ||
          filter.cancelSaleFunnelStepId ||
          filter.subscriptionFailedFunnelStepId
        }`
      : ''
  }${filter.webinarId ? `&filter[trigger][webinarId]=${filter.webinarId}` : ''}${
    filter.triggerCourseId ? `&filter[trigger][courseId]=${filter.triggerCourseId}` : ''
  }${filter.triggerModuleId ? `&filter[trigger][moduleId]=${filter.triggerModuleId}` : ''}${
    filter.triggerLectureId ? `&filter[trigger][lectureId]=${filter.triggerLectureId}` : ''
  }${
    filter.triggerCourseBundleId
      ? `&filter[trigger][courseBundleId]=${filter.triggerCourseBundleId}`
      : ''
  }${filter.triggerMailingId ? `&filter[trigger][mailingId]=${filter.triggerMailingId}` : ''}${
    filter.triggerLinkClickedId ? `&filter[trigger][linkId]=${filter.triggerLinkClickedId}` : ''
  }${
    filter.triggerCommunityId ? `&filter[trigger][communityId]=${filter.triggerCommunityId}` : ''
  }${
    filter.triggerDigitalStoreOptInId
      ? `&filter[trigger][itemOptInId]=${filter.triggerDigitalStoreOptInId}`
      : ''
  }${
    filter.triggerDigitalStoreId
      ? `&filter[trigger][digitalStoreId]=${filter.triggerDigitalStoreId}`
      : ''
  }${
    filter.triggerBookingEventId !== undefined
      ? `&filter[trigger][bookingEventId]=${filter.triggerBookingEventId}`
      : ''
  }${
    filter.triggerWebsiteId !== undefined
      ? `&filter[trigger][websiteId]=${filter.triggerWebsiteId}`
      : ''
  }${
    filter.triggerWebsitePageId !== undefined
      ? `&filter[trigger][pageId]=${filter.triggerWebsitePageId}`
      : ''
  }`
